export default "__VITE_ASSET__CrU1hYxV__"